

























































































































































import { Vue, Component } from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import TextField from "@/components/inputs/TextField.vue";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import { store } from "@/store";

class YargiBirimi {
  id!: number;
  isim!: string;
  uyap_kod!: string;
}

class Adliye {
  id!: number;
  isim!: string;
  uyap_kod!: string;
  uyap_org_kod!: string;
}

@Component({
  components: { EForm, Id, TextField, DeleteButton },
  computed: {
    store() {
      return store;
    }
  }
})
export default class YargiBirimiAdliye extends Vue {
  yargiBirimiDialog: boolean = false;
  yargiBirimiTitle: string = "";
  yargiBirimiAction: string = this.$store.state.icwApiUrl + "admin/yargi-birimi";
  yargiBirimiData: YargiBirimi = new YargiBirimi();
  yargiBirimleri: YargiBirimi[] = [];
  yargiBirimleriLoading: boolean = false;
  yargiBirimleriHeaders = [
    { text: "İlam Türü ID", value: "id" },
    { text: "İsim", value: "isim" },
    { text: "Uyap Kod", value: "uyap_kod" },
    { text: "İşlemler", value: "actions", align: "right" }
  ];
  yargiBirimiSearch: string = "";

  adliyeDialog: boolean = false;
  adliyeTitle: string = "";
  adliyeAction: string = this.$store.state.icwApiUrl + "admin/adliye";
  adliyeData: Adliye = new Adliye();
  adliyeler: Adliye[] = [];
  adliyelerLoading: boolean = false;
  adliyelerHeaders = [
    { text: "Şehir ID", value: "id" },
    { text: "İsim", value: "isim" },
    { text: "Uyap Kod", value: "uyap_kod" },
    { text: "Uyap Org Kod", value: "uyap_org_kod" },
    { text: "İşlemler", value: "actions", align: "right" }
  ];
  adliyeSearch: string = "";

  mounted() {
    this.loadYargiBirimleri();
    this.loadAdliyeler();
  }

  async loadYargiBirimleri() {
    try {
      this.yargiBirimleriLoading = true;
      const response = await this.$http.get(
          this.$store.state.icwApiUrl + "admin/yargi-birimleri"
      );
      this.yargiBirimleri = response.data;
    } catch (e) {
      console.error("Yargı Birimleri yüklenirken hata: ", e);
    } finally {
      this.yargiBirimleriLoading = false;
    }
  }

  addYargiBirimi() {
    this.yargiBirimiTitle = "Ekle";
    this.yargiBirimiData = new YargiBirimi();
    this.yargiBirimiAction = this.$store.state.icwApiUrl + "admin/yargi-birimi";
    this.yargiBirimiDialog = true;
  }

  editYargiBirimi(item: YargiBirimi) {
    this.yargiBirimiTitle = "Düzenle";
    this.yargiBirimiData = { ...item };
    this.yargiBirimiAction =
        this.$store.state.icwApiUrl + "admin/yargi-birimi/" + item.id;
    this.yargiBirimiDialog = true;
  }

  async loadAdliyeler() {
    try {
      this.adliyelerLoading = true;
      const response = await this.$http.get(
          this.$store.state.icwApiUrl + "admin/adliyeler"
      );
      this.adliyeler = response.data;
    } catch (e) {
      console.error("Adliyeler yüklenirken hata: ", e);
    } finally {
      this.adliyelerLoading = false;
    }
  }

  addAdliye() {
    this.adliyeTitle = "Ekle";
    this.adliyeData = new Adliye();
    this.adliyeAction = this.$store.state.icwApiUrl + "admin/adliye";
    this.adliyeDialog = true;
  }

  editAdliye(item: Adliye) {
    this.adliyeTitle = "Düzenle";
    this.adliyeData = { ...item };
    this.adliyeAction =
        this.$store.state.icwApiUrl + "admin/adliye/" + item.id;
    this.adliyeDialog = true;
  }
}
